var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutorenew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "autorenew_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "autorenew_svg__ds",
    x1: 78.31,
    y1: 167.56,
    x2: 387.3,
    y2: 167.56,
    gradientTransform: "translate(428) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m89.6,376.58c-6.78,0-12.3-5.52-12.3-12.3v-47c0-6.78,5.52-12.3,12.3-12.3h47.15c6.78,0,12.3,5.52,12.3,12.3s-5.52,12.3-12.3,12.3h-16.86c26.18,21.19,59.36,33.12,93.11,33.12,81.44,0,147.7-66.26,147.7-147.7,0-20.92-4.29-41.14-12.76-60.1-2.76-6.19.02-13.48,6.22-16.25,1.59-.71,3.27-1.07,5.01-1.07,4.85,0,9.26,2.86,11.24,7.29,9.88,22.13,14.89,45.73,14.89,70.13,0,95.01-77.29,172.3-172.3,172.3-40.43,0-80.19-14.68-111.1-40.67v17.65c0,6.78-5.52,12.3-12.3,12.3Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213,42.7c40.92,0,81.04,14.99,112.09,41.51v-16.62c0-6.78,5.52-12.3,12.3-12.3s12.3,5.52,12.3,12.3v47c0,6.78-5.52,12.3-12.3,12.3h-47.15c-6.78,0-12.3-5.52-12.3-12.3s5.52-12.3,12.3-12.3h18.13c-26.53-22.38-60.54-34.99-95.38-34.99-81.44,0-147.7,66.26-147.7,147.7,0,20.92,4.29,41.14,12.76,60.1,2.76,6.19-.02,13.48-6.22,16.25-1.59.71-3.28,1.07-5.01,1.07-4.85,0-9.26-2.86-11.24-7.29-9.88-22.13-14.89-45.72-14.89-70.13,0-95.01,77.29-172.3,172.3-172.3Z",
    style: {
      fill: "url(#autorenew_svg__ds)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorenew);
export default __webpack_public_path__ + "static/media/autorenew.2af2b1723df2fe8b52950f6ced4a86a9.svg";
export { ForwardRef as ReactComponent };